import React, { useEffect, useState, useRef } from 'react';
import { Button, LayerBottom, Layer } from 'components'

import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { transmitRequestSelector, selectedOrgsState,certTypeState,certFromState,selectedIndustriesSelector } from '../states'
import { useRecoilValue, useRecoilState } from 'recoil'
import { transmitRequestInfo, dataDetailTerms1Info } from './TermsInformations'
import {  manageCheckedResultState, manageCheckedResultIndsState } from 'views/mydata/manage/states'

import useCertifications from 'hooks/useCertifications'
import Lib from 'library'

const TransmitRequest1 = () => {

	const App = useApp()
	const mounted = useRef(false)
	const [transmitRequest, setTransmitRequest] = useRecoilState(transmitRequestSelector)
	const extendResult = useRecoilValue(manageCheckedResultState)

	const certFrom = useRecoilValue(certFromState)
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	const [industries, setIndustries] = useState()
	const recoilIndustries = useRecoilValue(certFrom === "extend" || certFrom === "modify" ? manageCheckedResultIndsState : selectedIndustriesSelector)
	const [buttonText, setButtonText] = useState("아래로 내려보기")
	const [atBottom, setAtBottom] = useState(false)
	const certType = useRecoilValue(certTypeState)
	const { goCommonCert, goNaverCert, goIndividualCert, goTestBedCert } = useCertifications()
	const core = useRef()

	const [cycleList, setCycleList] = useState([])
	const [termsList, setTermasList] = useState([])
	const [consentList, setConsentList] = useState([])

	
	const [agreeCollectUse, setAgreeCollectUse] = useState(false)
	const [agreeOffer, setAgreeOffer] = useState(false)

	const [showOptionCheckLayer, setShowOptionCheckLayer] = useState(false)
	const [showFullLayer, setShowFullLayer] = useState(false)
	const [addContentKey, setAddContentKey] = useState('')
	
	const onNext = (updatedRequest = null) => {
		const currentRequest = updatedRequest ?? transmitRequest
		
		if (atBottom) {
			if(!agreeOffer){
				setAgreeOffer(true)
			}
			if(!agreeCollectUse){
				setAgreeCollectUse(true)
			}
			// 선택항목 체크 필요(3종 확인하여 bottom layer노출하여 데이터 셋) - 공통으로 onNext 호출
			let addContent = {};
			if(recoilIndustries.indexOf("bank") > -1 || recoilIndustries.indexOf("efin") > -1){
				addContent.memo = currentRequest.memo
			}
			if(recoilIndustries.indexOf("card") > -1 || recoilIndustries.indexOf("efin") > -1 || recoilIndustries.indexOf("telecom") > -1 || recoilIndustries.indexOf("pcard") > -1){
				addContent.regno = currentRequest.regno
			}
			if(recoilIndustries.indexOf("efin") > -1){
				addContent.category = currentRequest.category
			}
			
			// 방법 1: 키만 반환
			const firstNullKey = Object.keys(addContent).find(key => addContent[key] == null || addContent[key] === undefined);
			if(firstNullKey){
				setAddContentKey(firstNullKey)
				setShowOptionCheckLayer(true)
			}else{

				switch (certType) {
					case 0: // 공동인증
						goCommonCert()
						break
					case 1: // 네이버인증
						goNaverCert()
						break
					case 2: // 사설인증
						goIndividualCert()
						break
					case 9999: // 테스트베드인증
						goTestBedCert()
						break
					default:
						break
				}
			}
			
		} else {
			const coreEl = core.current
			const step = coreEl.clientHeight * 0.8
			const maxTop = coreEl.scrollHeight - coreEl.clientHeight
			coreEl.scrollTo(0, Math.min(coreEl.scrollTop + step, maxTop))
		}
	}

	const bindScroll = () => {
		if (core.current.clientHeight >= core.current.scrollHeight - 30) {
			setAtBottom(true)
		}
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current ) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	useEffect(() => {
		let addContent = {};
		setTransmitRequest({...transmitRequest, ...addContent})
	}, [recoilIndustries])


	useEffect(() => {
		if (selectedOrgs) {
			const newList = []
			selectedOrgs.forEach(org => {
				if (!newList.some(industry => industry === org.indstCd)) {
					console.log("call newList.push", org.indstCd);
					newList.push(org.indstCd)
				}
			})
			console.log("call setIndustries", newList);
			setIndustries(newList)
		}
	}, [selectedOrgs])

	useEffect(() => {
		
		if (atBottom) {
			
			setButtonText("모두 동의하기")
		} else {
			setButtonText("아래로 내려보기")
		}
	}, [atBottom])


	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		core.current = document.querySelector(".core")
		mounted.current && bindScroll()

		console.log({selectedOrgs})
		if (certFrom === "extend") {
			getExtendConsents()
		}
		getSendCoCode()

		return () => mounted.current = false
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const getSendCoCode = async () => {
		// 전송주기
		Lib.get('/api/comm/cd/SEND_CYCLE', data => {
			// 전송요구 여부 디폴트 '예'
			if (certFrom !== "extend") {
				setTransmitRequest({
					isScheduled: true
				})
			}
			setCycleList(data);
			if (certFrom !== "extend" && data.length > 0) {
				setTransmitRequest({
					isCycle: data[0].commCd
				})
			}
		})
		// 전송기간
		Lib.get('/api/comm/cd/SEND_TERMS', data => {
			console.log(data)
			data.forEach((item)=>{
				if(item.commCd === '5'){
					setTransmitRequest({
						endTerms: item.commCd
					})
				}
			})
			setTermasList(data)
		})
	}

	const getExtendConsents = async () => {
		const array = []
		console.log("extendResult", extendResult)
		extendResult.forEach(item => {
			array.push(new Promise(resolve => {
				Lib.get(`/api/lnkup/data/mgmt/${item.reqCd}/consents`, data => {
					resolve(data)
				})
			}))
		})
		const result = await Promise.all(array)
		console.log({ result })
		setConsentList(result)
	}

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["count-group"]}>
					<p>안전한 정보 확인을 위한 동의</p>
					<div><span>3</span>/4</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40 pb_100`}>
					
					<span className="mt_10">
						(주)핀테크는 「신용정보의 이용 및 보호에 관한 법률」, 「개인정보 보호법」 등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
					</span>
					<p className="mt_20">개인(신용)정보 수집 • 이용 동의 및 전송요구서</p>
					<ul className="mt_20">
					
						<li>
							<div>정보제공자</div>
							<span className={styles["consent-text-blue"]}>
								{
									selectedOrgs &&
									selectedOrgs.map((item, index) => {
										return <span className="ml_5" key={index}>{item.insttNm}{index < selectedOrgs.length - 1 && ", "}</span>
									})
								}
							</span>
						</li>
						<li>
							<div>제공받는자</div>
							<span>{App.comName}</span>
						</li>
						<li>
							<div>목적</div>
							<span className={styles["consent-text-blue"]}>전송요구를 통한 본인신용정보 통합조회, 데이터분석 서비스의 이용</span>
						</li>
						<li>
							<div>종료시점 및 보유 • 이용기간</div>
							{/* <p className="text-blue mt_10">서비스 이용 종료시, 삭제 요구 시 또는 마지막 서비스 로그인 일로부터 1년이 경과한 때까지 중 가장 먼저 도래하는 기한</p> */}
							<span className={styles["consent-text-blue"]}>서비스 이용 종료시, 삭제 요구 시 또는 마지막 서비스 로그인 일로부터 1년이 경과한 때까지 중 가장 먼저 도래하는 기한</span>
						</li>
						<li>
							<div>전송 요구 정보</div>
						
							<div className={styles.category}>
								<div>
									<div className="pl_10">
										{
											industries &&
											industries.map((item, index) => {
												if(dataDetailTerms1Info[item]){
													return (
														<div key={index} className={index > 0 ? "mt_5" : undefined}>
															<div className={`bold ${styles["bullet-item"]}`} style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>{dataDetailTerms1Info[item].name} : {dataDetailTerms1Info[item].data}</div>
															
														</div>
													)

												}else{
													return ""
												}
											})
										}
									</div>
								</div>
							</div>
						</li>
						<li>

							<span className='mb_10'>전자서명, 접근토큰, 인증서, 전송요구서 개인(식별) 정보는 <span className={`text-blue bold `} style={{textDecoration: 'underline',textUnderlineOffset: '2px'}} onClick={()=>{setShowFullLayer(true)}}>수집·이용정보를</span> 통해 확인할 수 있습니다.</span>
							<div>거부 권리 및 불이익</div>
						
							<span>
								개인(신용)정보 수집•이용 필수 항목 동의를 하지 않을 경우 본인 신용정보 통합 조회 및 데이터 분석 서비스 이용이 제한됩니다. 선택 항목 동의를 하지 않을 경우 해당 항목 관련 서비스 이용이 제한될 수 있습니다.
							</span>
						</li>
						<li>
							
						
							<p>정기적 전송 요구 여부 및 주기(주/1회)</p>
							<div className='btn-group--inline btn-group  flex-shrink_0 mt_10'>
								<Button className={`btn btn--md btn--gray_line ${transmitRequest.isScheduled === false ? " selected" : ""}`} onClick={()=>{
									if (certFrom === "extend") return
									setTransmitRequest({
										isScheduled: false,
										isCycle: undefined,
									})
								}}>아니오</Button>
								<Button className={`btn btn--md btn--gray_line ml_10 ${transmitRequest.isScheduled === true ? " selected" : ""}`} onClick={()=>{
									if (certFrom === "extend") return
									setTransmitRequest({
										isScheduled: true,
										isCycle: cycleList[0].commCd
									})
								}}>예</Button>
							</div>
							
						

							{cycleList.length > 0 &&
								transmitRequest.isScheduled === true &&
							
								<div className="flex-align_center mt_15">
								{cycleList.map((item, index) => {
									return <div key={index} className="chk flex--item_1 flex-align_center" onClick={e => {
										if (certFrom === "extend") return
											setTransmitRequest({
												isCycle: item.commCd
											})
									}}>
										<input type="radio" id={`cycle-${index}`} className={`mr_10 `} readOnly checked={transmitRequest.isCycle === item.commCd} />
										<label htmlFor={`cycle-${index}`}>
											<span>{item.commNm}</span>
										</label>
										
									</div>
								})}
							</div>
							}
							<div className={`${styles["warning"]} mt_10`}>※ 6개월동안 미로그인시 정기적 전송 자동 중단</div>
						</li>
						<li>
							<p>전송요구의 종료시점</p>
							{termsList.length > 0 && <div className='btn-group--inline btn-group  flex-shrink_0 mt_10'>
								{
									termsList.map((item, index) =>{
										let borderRadiusClass = "";
										if(index === 0) {
											borderRadiusClass = "left";
										}else if(index === termsList.length - 1) {
											borderRadiusClass = "right";
										}
										
										return <Button key={index} className={`btn btn--sm ${borderRadiusClass} horizontal btn--gray_line  ${transmitRequest.endTerms === item.commCd ? " selected" : ""}`} onClick={()=>{
											
											if (certFrom === "extend") return
											setTransmitRequest({
												endTerms: item.commCd
											})
										}}>{item.commNm}</Button> 
									})
								}
							</div>
							}
						</li>
					</ul>
					{
					(recoilIndustries.indexOf("bank") > -1 || recoilIndustries.indexOf("card") > -1 || recoilIndustries.indexOf("efin") > -1 || recoilIndustries.indexOf("telecom") > -1 || recoilIndustries.indexOf("pcard") > -1) &&
					<p className="mt_40">선택항목</p>
					}
					<ul className="mt_10">
						{
							(recoilIndustries.indexOf("bank") > -1 || recoilIndustries.indexOf("efin") > -1) &&
							<li>
								<p>적요 또는 거래메모 정보</p>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래내역의 적요 또는 거래메모 정보에는 송금인/수취인명 정보 등 본인의 사생활 및 경제활동 등에 관련된 상세한 정보가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className='btn-group--inline btn-group  flex-shrink_0 mt_10'>
												<Button className={`btn btn--md btn--gray_line ${transmitRequest.memo === false ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.memo === false) return
													setTransmitRequest({
														memo: false
													})
												}}>수집 미동의</Button>
												<Button className={`btn btn--md btn--gray_line ml_10 ${transmitRequest.memo === true ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.memo === true) return
													setTransmitRequest({
														memo: true
													})
												}}>수집 동의</Button>
											</div>
											
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/bank|efin/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.tradeMemoAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
														return ""
													})
												}
											</tbody>
										</table>
								}
							</li>
						}
						{
							(recoilIndustries.indexOf("card") > -1 || recoilIndustries.indexOf("efin") > -1 || recoilIndustries.indexOf("telecom") > -1 || recoilIndustries.indexOf("pcard") > -1) &&
							<li>
								<p>가맹점명 및 사업자등록번호 정보</p>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래(결제)내역의 가맹점 및 사업자등록번호 정보에는 본인의 소비생활 등에 관련된 상세한 정보가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className='btn-group--inline btn-group  flex-shrink_0 mt_10'>
												<Button className={`btn btn--md btn--gray_line ${transmitRequest.regno === false ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.regno === false) return
													setTransmitRequest({
														regno: false
													})
												}}>수집 미동의</Button>
												<Button className={`btn btn--md btn--gray_line ml_10 ${transmitRequest.regno === true ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.regno === true) return
													setTransmitRequest({
														regno: true
													})
												}}>수집 동의</Button>
											</div>
											
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/card|efin|telecom|pcard/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.mbbsNmInfAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
														return ""
													})
												}
											</tbody>
										</table>
								}
							</li>
						}

						{
							recoilIndustries.indexOf("efin") > -1 &&
							<li>
								<p>상품구매정보</p>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래(결제)내역의 상품구매정보에는 실제 구매한 상품이 아닌 해당 상품의 카테고리(13 항목으로 구분)가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className='btn-group--inline btn-group  flex-shrink_0 mt_10'>
												<Button className={`btn btn--md btn--gray_line ${transmitRequest.category === false ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.category === false) return
													setTransmitRequest({
														category: false
													})
												}}>수집 미동의</Button>
												<Button className={`btn btn--md btn--gray_line ml_10 ${transmitRequest.category === true ? " selected" : ""}`} onClick={()=>{
													if (certFrom === "extend" || transmitRequest.category === true) return
													setTransmitRequest({
														category: true
													})
												}}>수집 동의</Button>
											</div>
											
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/efin/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.prodBuyInfAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
														return ""
													})
												}
											</tbody>
										</table>
								}
							</li>
						}
					</ul>
					<p className="mt_30">개인(신용)정보 제공 동의</p>
					<ul className="mt_20">
						<li>
							<div>정보제공자</div>
							<span className={styles["consent-text-blue"]}>
							{
									selectedOrgs &&
									selectedOrgs.map((item, index) => {
										return <span className="ml_5" key={index}>{item.insttNm}{index < selectedOrgs.length - 1 && ", "}</span>
									})
								}
							</span>
						</li>
						<li>
							<div>목적</div>
							<span className={styles["consent-text-blue"]}>
								본인확인 및 개인(신용)정보의 전송
							</span>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<span className={styles["consent-text-blue"]}>
								본인확인 및 개인(신용정보)의 전송 목적 달성시까지
							</span>
						</li>
						<li>
							<div>제공정보</div>
							<span>
								전자서명, CI, 인증서, 전송요구서
							</span>
						</li>
						<li>
							<div>정보제공자</div>
							<span className={styles["consent-text-blue"]}>
								한국신용정보원
							</span>
						</li>
						<li>
							<div>목적</div>
							<span className={styles["consent-text-blue"]}>
								마이데이터서비스 가입현황 안내 및 전송요구 내역 통합조회 서비스 제공
							</span>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<span className={styles["consent-text-blue"]}>
								한국신용정보원의 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 목적 달성시 까지
							</span>
						</li>
						<li>
							<div>제공항목</div>
							<span>
								회원 가입여부, 서비스목록수, 서비스목록, 클라이언트ID, 전송요구내역수, 전송요구내역목록, 정보제공자 기관코드, 권한 범위, 전송요구 일자, 전송요구종료시점
							</span>
						</li>
						<li>
							<div>거부 권리 및 불이익</div>
							<span >
							개인(신용)정보 제공에 관한 동의를 거부하실 수 있습니다. 다만, 개인(신용)  정보의 제공에 관한 동의는 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터 서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 이용과 직접적으로 관련된  필수적 사항이므로 아래의 사항에 동의하셔야만 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스의 제공이 가능합니다.
							</span>
						</li>
					</ul>

					<div className="chk flex-align_center mt_30" onClick={e => {
						setAgreeCollectUse(!agreeCollectUse)
					}}>
						<span className={`mr_10 checkMark${agreeCollectUse ? " on" : ""}`} />
						<span>개인(신용)정보 수집·이용 동의</span>
					</div>
					<div className="chk flex-align_center mt_20" onClick={e => {
						setAgreeOffer(!agreeOffer)
					}}>
						<span className={`mr_10 checkMark${agreeOffer ? " on" : ""}`} />
						<span>개인(신용)정보 제공 동의</span>
					</div>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				
				<Button className="btn btn--big"  onClick={()=>onNext()}>{buttonText}</Button>
			</div>

			<FullLayer  show={showFullLayer} closeLayer={() => setShowFullLayer(false)} industries={industries}></FullLayer>
			<Bottom 
				show={showOptionCheckLayer} 
				closeLayer={() => setShowOptionCheckLayer(false)} 
				addContentKey={addContentKey} 
				onNext={(value)=>{
					const updatedRequest = {...transmitRequest, [addContentKey]: value}
					setTransmitRequest(updatedRequest); 
					setShowOptionCheckLayer(false);
					onNext(updatedRequest);
				}}
			/>
		</div>
	)
}
const FullLayer = ({  show, closeLayer,industries }) => {
	return (
		<Layer show={show} closeLayer={closeLayer} title="개인(신용)정보 수집·이용 동의서">
			<div className="page">
				<div className="padding">
					<div className={`${styles["terms-area"]}  pb_10`}>
						<span>
							㈜핀테크는 「신용정보의 이용 및 보호에 관한 법률」, 「개인정보 보호법」 등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
						</span>
						<ul className="mt_20">
							<li>
								<div>수집 이용 목적</div>
								<span>
								전송요구를 통한 본인신용정보 통합조회, 데이터분석 서비스의 이용
								</span>
							</li>
							<li>
								<div>보유 및 이용기간</div>
								<span>
									아래 중 가장 먼저 도래하는 기간까지
									<div className="pl_10">
										<div className={` ${styles["bullet-item"]}`} style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>
											연결해제(또는 전송요구의 종료시 점) 후 삭제요구시
										</div>
										<div className={` ${styles["bullet-item"]}`} style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>
											마지막 서비스 로그인 일로부터 1년이 경과한 때
										</div>
										<div className={` ${styles["bullet-item"]}`} style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>
											서비스 해지 시(다만, 관계 법령에 따라 보존할 필요가 있는 경우 법령상의 보존기간을 따름)

										</div>
									</div>
								</span>
							</li>
							<li>
								<div>
									거부 권리 및 불이익
								</div>
								<span>
								귀하는 개인(신용)정보 수집•이용에 관한 동의를 거부하실 수 있습니다. 다만, "수집•이용에 관한 동의"는 본인신용정보 통합조회, 데이터분석 서비스의 이용을 위한 필수적 사항이므로 동의를 거부하실 경우 본인신용정보 통합조회, 데이터분석 서비스의 이용이 제한 될 수 있습니다.
								</span>
							</li>
						</ul>
						<p className='mt_20 '>※ 개인(신용) 정보의 수집·이용 항목</p>
						<ul className="mt_20">
							<li>
								<div>
									개인(식별) 정보
								</div>
								<span>
									전자서명 접근토큰, 인증서, 전송요구서
								</span>
							</li>
							<li>
								<div>
									신용 거래 정보
								</div>
								<div className={styles.category}>
									<div>
										<div className="pl_10">
											{
												industries &&
												industries.map((item, index) => {
													if(transmitRequestInfo[item]){
														return (
															<div key={index} className={index > 0 ? "mt_5" : undefined}>
																<div className={`bold ${styles["bullet-item"]}`} style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>{transmitRequestInfo[item].name} : {transmitRequestInfo[item].data}</div>
																
															</div>
														)

													}else{
														return ""
													}
												})
											}
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
					<div className={` padding`}>
				
						<Button className="btn btn--big" onClick={closeLayer}>닫기</Button>
					</div>
			</div>
			
		</Layer>
	)
}

const Bottom = ({ show, closeLayer, addContentKey, onNext }) => {
	let layerText1 = '';
	let layerText2 = '';
	if(addContentKey === 'memo'){
		layerText1 = `계좌 정보의 입·출금 정보를 가져올까요?`
		layerText2 = `적요 또는 거래 메모 정보 및 수집·이용동의`;
	}else if(addContentKey === 'regno'){
		layerText1 = '어디서 결제했는지 정보를 가져올까요?'
		layerText2 = '가맹점명 사업자등록번호 정보 전송 및 수집·이용 동의';
	}else if(addContentKey === 'category'){
		layerText1 = '상품 구매 정보를 가져올까요?'
		layerText2 = '상품 카테고리 정보 전송 및 수집·이용 동의';
	}
	return (
		<LayerBottom 
			show={show} 
			closeLayer={closeLayer}
		>
			<div className="layer-text mt_30">
				{layerText1}<br/>{layerText2}
				<div className='btn-group--inline btn-group  flex-shrink_0 mt_20'>
					<Button className="btn btn--md py_15" onClick={()=>onNext(false)}>미동의</Button>
					<Button className="btn btn--md py_15 ml_10" onClick={()=>onNext(true)}>동의하기</Button>
				</div>
			</div>
		</LayerBottom>
	)
}

export default TransmitRequest1